export enum TicketsPageSize {
    full = 'full',
    compact = 'compact',
    onlyCheckout = 'onlyCheckout',
}
